import { useContext, useEffect, useState } from 'react';
import { Content, Count, Filter, FilterContainer, Title } from '../styles';
import { AccountsContext } from 'contexts/accounts';
import { isAllPricing } from './utils';
import { CheckboxChangeEvent } from 'antd/lib/checkbox';
import Checkbox from 'components/checkbox';
import {
  getPricingCount,
  getPricingPlanFilterOptions,
} from 'pages/Accounts/components/AccountsFilters/Filters/utils';
import { getPricingPlanIdentity, isLegacyPricingPlan } from 'contexts/pricingPlans/identity';
import PricingPlanLabel from 'pages/Accounts/components/PricingPlanLabel';

const PricingPlan: React.FC = (): JSX.Element => {
  const { filters, actions, counts } = useContext(AccountsContext);
  const [allPricing, setAllPricing] = useState(isAllPricing({ plan: filters.pricing_plan }));
  // Keep the backend order, but move legacy plan variants below their current counterparts.
  const pricingPlanOptions = [...getPricingPlanFilterOptions(counts)].sort(
    (a, b) => Number(isLegacyPricingPlan(a)) - Number(isLegacyPricingPlan(b))
  );

  useEffect(() => {
    const isAll = isAllPricing({ plan: filters.pricing_plan });
    setAllPricing(isAll);
  }, [filters.pricing_plan]);

  const setFilter = (e: React.ChangeEvent<HTMLInputElement> | CheckboxChangeEvent) => {
    const name = e.target.name;
    if (name) {
      const value = e.target.value;
      const isNotAll = value !== 'pricing_all';
      const isMultipleValue = ['pricing_plan'].includes(name) && isNotAll;
      actions &&
        actions.onChangeFilters({
          name: name,
          value: value,
          multiple: isMultipleValue,
        });
      actions.clearSelectedItems();
    }
  };

  return (
    <FilterContainer>
      <Title>Pricing plan</Title>
      <Content>
        <Filter>
          <Checkbox
            label="All"
            value="pricing_all"
            id="pricing_all"
            name="pricing_plan"
            onChange={setFilter}
            defaultChecked={allPricing}
            checked={allPricing}
            controlled
          />
        </Filter>
        <Count>
          {getPricingCount({ name: 'all', code: null, legacy: null, count: 0 }, counts)}
        </Count>
      </Content>
      {pricingPlanOptions.map((plan) => {
        const identity = getPricingPlanIdentity(plan);
        const isLegacy = isLegacyPricingPlan(plan);
        return (
          <Content key={identity}>
            <Filter>
              <Checkbox
                label={<PricingPlanLabel name={plan.name} legacy={isLegacy} />}
                value={plan.filterValue}
                id={
                  plan.legacy === null || plan.legacy === undefined
                    ? `pricing_${plan.filterValue}`
                    : `pricing_${identity.replace(/[^a-z0-9]/gi, '_')}`
                }
                name="pricing_plan"
                onChange={setFilter}
                defaultChecked={filters.pricing_plan.includes(plan.filterValue)}
                checked={filters.pricing_plan.includes(plan.filterValue)}
                controlled
              />
            </Filter>
            <Count>{getPricingCount(plan, counts)}</Count>
          </Content>
        );
      })}
    </FilterContainer>
  );
};

export default PricingPlan;
